import React from 'react';
import { Heart, FileText } from '../icons';

function TermsOfService() {
  return (
    <div style={{ minHeight: '100vh', background: '#fafafa' }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)', color: '#fff', padding: '60px 24px', textAlign: 'center' }}>
        <FileText size={48} style={{ marginBottom: '16px', opacity: 0.9 }} />
        <h1 style={{ fontSize: '2.4rem', fontWeight: '800', margin: '0 0 12px' }}>Terms of Service</h1>
        <p style={{ fontSize: '1.1rem', opacity: 0.85, margin: 0 }}>Effective Date: January 1, 2025 &nbsp;·&nbsp; Last Updated: May 1, 2026</p>
      </div>

      {/* Content */}
      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '48px 24px 80px' }}>
        <div style={{ background: '#fff', borderRadius: '16px', padding: '40px 48px', boxShadow: '0 2px 16px rgba(0,0,0,0.07)' }}>

          <p style={{ color: '#374151', lineHeight: 1.8, fontSize: '1rem', marginBottom: '32px' }}>
            Please read these Terms of Service carefully before using <strong>nepwed.com</strong>. By accessing or using NepWed, you agree to be bound by these terms. If you do not agree, please do not use our platform.
          </p>

          <Section title="1. Acceptance of Terms">
            <p>These Terms of Service ("Terms") constitute a legally binding agreement between you and <strong>NepWed</strong> governing your use of our website and wedding planning services. By creating an account or using any part of our platform, you confirm that you are at least 18 years of age and have the legal capacity to enter into this agreement.</p>
          </Section>

          <Section title="2. Description of Services">
            <p>NepWed provides an online wedding planning platform designed for Nepali weddings that includes:</p>
            <ul>
              <li>Wedding vendor discovery and inquiry tools</li>
              <li>Wedding checklist and task management</li>
              <li>Budget tracking and expense management</li>
              <li>Guest list and RSVP management</li>
              <li>Personalized wedding website creation</li>
              <li>Digital invitations and media gallery</li>
              <li>Family collaboration tools</li>
            </ul>
            <p>We reserve the right to modify, suspend, or discontinue any part of our services at any time with reasonable notice.</p>
          </Section>

          <Section title="3. User Accounts">
            <p>You are responsible for:</p>
            <ul>
              <li>Providing accurate and complete registration information</li>
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activity that occurs under your account</li>
              <li>Notifying us immediately of any unauthorized use of your account</li>
            </ul>
            <p>You may not create an account on behalf of another person without their consent, or use another person's account without permission.</p>
          </Section>

          <Section title="4. Vendor Listings and Interactions">
            <p>NepWed acts as a marketplace platform that connects couples with wedding vendors. We do not:</p>
            <ul>
              <li>Endorse, guarantee, or take responsibility for any vendor's services, quality, pricing, or conduct</li>
              <li>Participate in or mediate transactions between users and vendors</li>
              <li>Guarantee the accuracy of vendor information listed on our platform</li>
            </ul>
            <p>You agree to conduct your own due diligence before engaging any vendor. NepWed is not liable for any disputes arising between users and vendors.</p>
          </Section>

          <Section title="5. User Content">
            <p>You may upload photos, videos, text, and other content ("User Content") to NepWed. By submitting User Content, you grant NepWed a non-exclusive, royalty-free license to display and use your content solely to provide our services.</p>
            <p>You represent that you own or have the necessary rights to all content you upload, and that your content does not:</p>
            <ul>
              <li>Infringe any third-party intellectual property rights</li>
              <li>Contain false, misleading, or defamatory material</li>
              <li>Include obscene, hateful, or illegal content</li>
              <li>Violate any applicable laws or regulations of Nepal</li>
            </ul>
            <p>We reserve the right to remove any content that violates these Terms without prior notice.</p>
          </Section>

          <Section title="6. Vendor Registration and Reviews">
            <p>Vendors who register on NepWed agree to provide accurate business information and maintain professional standards of service. Vendors must not post fake reviews or manipulate ratings. NepWed reserves the right to suspend or remove vendor accounts found in violation of our policies.</p>
            <p>User-submitted reviews must be honest and based on genuine experiences. Fabricated reviews, whether positive or negative, are strictly prohibited.</p>
          </Section>

          <Section title="7. Wedding Websites">
            <p>When you create a public wedding website on NepWed, you acknowledge that:</p>
            <ul>
              <li>Your published wedding website is accessible to anyone who has the link</li>
              <li>You are responsible for the content you publish</li>
              <li>NepWed may remove websites that violate our content policies</li>
            </ul>
          </Section>

          <Section title="8. Intellectual Property">
            <p>All content, features, and functionality of the NepWed platform — including design, logos, text, graphics, and software — are the exclusive property of NepWed and are protected under applicable intellectual property laws. You may not copy, reproduce, or distribute our platform content without written permission.</p>
          </Section>

          <Section title="9. Limitation of Liability">
            <p>To the fullest extent permitted by applicable law, NepWed shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the platform, including but not limited to: loss of data, vendor disputes, wedding cancellations, or service interruptions.</p>
            <p>Our total liability to you for any claims arising from these Terms or your use of NepWed shall not exceed the amount paid by you to NepWed in the twelve months preceding the claim.</p>
          </Section>

          <Section title="10. Prohibited Conduct">
            <p>You agree not to:</p>
            <ul>
              <li>Use NepWed for any unlawful purpose or in violation of these Terms</li>
              <li>Attempt to gain unauthorized access to any part of our platform or systems</li>
              <li>Scrape, crawl, or use automated tools to extract data without permission</li>
              <li>Post spam, unsolicited messages, or commercial advertisements</li>
              <li>Impersonate any person, vendor, or organization</li>
              <li>Interfere with or disrupt the integrity or performance of the platform</li>
            </ul>
          </Section>

          <Section title="11. Termination">
            <p>We reserve the right to suspend or terminate your account at our sole discretion if you violate these Terms, engage in fraudulent activity, or harm other users. You may also delete your account at any time by contacting us.</p>
            <p>Upon termination, your right to use NepWed ceases immediately. Provisions of these Terms that by their nature should survive termination shall remain in effect.</p>
          </Section>

          <Section title="12. Governing Law">
            <p>These Terms are governed by and construed in accordance with the laws of Nepal. Any disputes arising under these Terms shall be subject to the jurisdiction of the courts of Kathmandu, Nepal.</p>
          </Section>

          <Section title="13. Changes to Terms">
            <p>We may revise these Terms at any time. When we make material changes, we will notify users by updating the "Last Updated" date and, where appropriate, by sending an email notification. Your continued use of NepWed after changes are posted constitutes acceptance of the revised Terms.</p>
          </Section>

          <Section title="14. Contact Us">
            <p>If you have questions about these Terms, please contact us:</p>
            <p>
              <strong>NepWed</strong><br />
              Durbar Marg, Kathmandu, Nepal<br />
              Email: <a href="mailto:contact@nepwed.com" style={{ color: '#DC143C' }}>contact@nepwed.com</a>
            </p>
          </Section>

          <div style={{ marginTop: '48px', padding: '24px', background: '#f8fafc', borderRadius: '12px', textAlign: 'center', color: '#475569' }}>
            <Heart size={20} style={{ verticalAlign: 'middle', marginRight: '8px', color: '#DC143C' }} />
            By using NepWed, you agree to these Terms and help us build a better wedding planning experience for every Nepali couple.
          </div>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '36px' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#111827', marginBottom: '12px', paddingBottom: '8px', borderBottom: '2px solid #e2e8f0' }}>{title}</h2>
      <div style={{ color: '#374151', lineHeight: 1.8, fontSize: '0.97rem' }}>
        {children}
      </div>
    </div>
  );
}

export default TermsOfService;
